import { render, staticRenderFns } from "./clodProduct.vue?vue&type=template&id=1c430cce&scoped=true"
import script from "./clodProduct.vue?vue&type=script&lang=js"
export * from "./clodProduct.vue?vue&type=script&lang=js"
import style0 from "./clodProduct.vue?vue&type=style&index=0&id=1c430cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c430cce",
  null
  
)

export default component.exports